























import { Component, Vue, Prop } from 'vue-property-decorator';
import { GQL_webstoreApiTokenList_currentUnit_webstoreApiTokens } from '@/queries/__generated__/webstoreApiTokenList';
import gql from 'graphql-tag';

const DELETE_WEBSTORE_API_TOKEN = gql`
  mutation deleteWebstoreApiToken($id: ID!) {
    deleteWebstoreApiToken(
      input: {
        id: $id
      }
    ) {
      webstoreApiToken {
        id
      }
    }
  }
`;

@Component
export default class WebstoreApiTokenDeleteButton extends Vue {
  @Prop() private webstoreApiToken!: GQL_webstoreApiTokenList_currentUnit_webstoreApiTokens;
  private DELETE_WEBSTORE_API_TOKEN = DELETE_WEBSTORE_API_TOKEN;

  private confirmDelete(confirmMutation: () => {}) {
    this.$sPopup.confirm('', {
      title: this.$t('PopupTitle.confirmDelete'),
      message: this.$t('PopupBody.confirmDelete', { thing: `${this.$t('WebstoreApiToken.apiToken')} - ${this.webstoreApiToken.description}` }),
      onConfirm: confirmMutation,
    });
  }
}
